import React from 'react';

export interface ACProgressProps {
  value: number;
  max?: number;
  bgColor?: string;
  isGroup?: boolean;
}

export const ACProgress = ({ value, bgColor, max = 100, isGroup = false }: ACProgressProps) => {
  const percentage = (value / max) * 100;
  if (percentage > 0) {
    return (
      <div className="w-full bg-[#deddf0] overflow-hidden">
        <div
          className={`h-2.5 ${!bgColor && 'bg-[#06D1DF]'} transition-all duration-300 ease-in-out`}
          style={{ width: `${percentage}%`, backgroundColor: isGroup ? bgColor : '#06D1DF' }}
        ></div>
      </div>
    );
  }

  return null;
};
